// extracted by css-extract-rspack-plugin
export default {"avatarStack":"AssigneesMetadata-module__avatarStack__recCY","avatar":"AssigneesMetadata-module__avatar__SdD12"};